import { render, staticRenderFns } from "./TextWithLinkAndBgimage.vue?vue&type=template&id=2f88d37c&scoped=true&"
import script from "./TextWithLinkAndBgimage.vue?vue&type=script&lang=js&"
export * from "./TextWithLinkAndBgimage.vue?vue&type=script&lang=js&"
import style0 from "./TextWithLinkAndBgimage.vue?vue&type=style&index=0&id=2f88d37c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f88d37c",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AppImage: require('/vercel/path0/components/general/AppImage.vue').default,ArrowLink: require('/vercel/path0/components/general/ArrowLink.vue').default,Container: require('/vercel/path0/components/general/Container.vue').default,SelectableBgColor: require('/vercel/path0/components/general/SelectableBgColor.vue').default})
